import React from 'react';
import PropTypes from 'prop-types';
import { animated, Spring } from 'react-spring';
import styled from 'styled-components';
import { ButtonRounded, Icon, SubHeading } from '../../elements';
import Portal from '../Portal';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-bottom: 1rem;
`
const CloseButton = styled(ButtonRounded)`
  align-self: flex-end;
  
  margin: 0;
`;
const Head = styled(SubHeading)`
  flex: 1;
  margin: 0;
`
const ModalWrapper = styled.div`
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
`;

const ModalContent = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  padding: 1rem;
  background: #ffffff;
  min-height: 300px;
  top: 50%;
  transform: translateY(-50%);
  max-width: 1050px;
  margin: 0 auto;
`;

const Modal = ({ isVisible, onRequestClose, heading, children }) => {
  return !isVisible ? null : (
    <Portal>
      <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }} delay={200}>
        {(styles) => (
          <animated.div style={{ ...styles }}>
            <ModalWrapper>
              <ModalContent>
                <HeaderContainer>
                  {heading && <Head>{heading}</Head>}
                  <CloseButton onClick={onRequestClose}>
                    <Icon>close</Icon>
                  </CloseButton>
                </HeaderContainer>
                {children}
              </ModalContent>
            </ModalWrapper>
          </animated.div>
        )}
      </Spring>
    </Portal>
  );
};

Modal.propTypes = {
  isVisible: PropTypes.bool,
  onRequestClose: PropTypes.func,
};

export default Modal;
